// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"42bf14c2","453":"2ef3063a","455":"62d47637","977":"46c0d4b2"}[chunkId] + ".chunk.js";
};